import {useCryptoBalances} from "./_use-crypto-balances.js";
import './CryptoBalances.scss'
import Card from "../util/card/Card.jsx";
import ExternalLink from "../util/ExternalLink.jsx";
import Counter from "../util/Counter.jsx";
import {DECIMAL_FORMAT} from "../../util/numbers.js";
import useLazyListLoader from "../util/lasy-loader/useLazyListLoader.js";
import {formatEthereumAddress} from "../../util/misc.js";
import {getUsdRate} from "../../ducks/assets-duck.js";
import {useSelector} from "react-redux";
import Assets from "./Assets.jsx";
import Table from "../util/table/Table.jsx";
import ExternalLinkIcon from "mdi-react/ExternalLinkIcon.js";
import dayjs from "dayjs";
import TimeDiff from "../util/TimeDiff.jsx";
import {DAY, MONTH, WEEK} from "../../util/time-and-date.js";
import DatabaseOutlineIcon from "mdi-react/DatabaseOutlineIcon.js";
import ClockOutlineIcon from "mdi-react/ClockOutlineIcon.js";

export default () => {
    const {accounts = [], assets = [], toggleSort, isSortedByValue} = useCryptoBalances()
    const usdRate = useSelector(getUsdRate)

    const totalValue = accounts.reduce((acc, cur) => acc + cur.totalValue, 0)

    const {visibleList, ListLoaderComponent} = useLazyListLoader(accounts, 10, 3)
    return (
        <div className='crypto-balances'>
            <div className='total-value'>
                <h3>
                    Sum value all assets
                </h3>
                <Counter
                    className={'total-value-nok'}
                    amount={totalValue}
                    suffix='kr'
                />
            </div>
            <Assets assets={assets}/>
            <button className='sort-toggle flex-vertical-center' onClick={toggleSort}>
                <div className='dull'>
                    order by
                </div>
                <div className='prop'>
                    {isSortedByValue ? 'value' : 'activity'}
                </div>
                {isSortedByValue ? <DatabaseOutlineIcon/> : <ClockOutlineIcon/>}
            </button>
            {visibleList.map(account =>
                <Account
                    key={account.address}
                    usdRate={usdRate}
                    {...account}
                />
            )}
            <ListLoaderComponent/>
        </div>
    )
}

const Account = ({comment, address, totalValue, location, usdRate = 0, assets = [], lastActivity}) => {
    const msSinceLastActivity = dayjs().diff(lastActivity)
    let timeAgoClass = 'lvl-0'
    if (msSinceLastActivity < DAY) {
        timeAgoClass = 'lvl-3'
    } else if (msSinceLastActivity < WEEK) {
        timeAgoClass = 'lvl-2'
    } else if (msSinceLastActivity < MONTH) {
        timeAgoClass = 'lvl-1'
    }
    return (
        <Card className='account'>
            <div className='header'>
                <div className='description'>
                    <div className='comment'>
                        {comment}
                    </div>
                    <div className='value flex-vertical-center'>
                        <Counter
                            amount={totalValue}
                            decimals={0}
                            suffix={'kr'}
                        />
                        <Counter
                            className='usd-value'
                            amount={totalValue / usdRate}
                            decimals={DECIMAL_FORMAT.FLEX}
                            prefix='$'
                        />
                    </div>
                </div>
                <div>
                    <div className='address flex-vertical-center'>
                        <ExternalLink href={`https://forgotteneth.com/?address=${address}`} className='debank-link'>
                            FE
                        </ExternalLink>
                        <ExternalLink href={`https://debank.com/profile/${address}`} className='debank-link'>
                            DB
                        </ExternalLink>
                        <ExternalLink href={`https://etherscan.io/address/${address}`}>
                            {formatEthereumAddress(address, 5)}
                        </ExternalLink>
                    </div>
                    <div className='location'>
                        {location}
                    </div>
                </div>
            </div>
            {lastActivity &&
            <div className='last-activity flex-vertical-center'>
                <TimeDiff date={lastActivity} className={timeAgoClass}/>
                <div className={'small'}>
                    {dayjs(lastActivity).format('YYYY-MM-DD')}
                </div>
            </div>
            }
            <div className='asset-balances flex-vertical-center'>
                <Table className='rounded'>
                    <tbody>
                    {assets.map(asset =>
                        <Asset
                            key={asset.tokenAddress}
                            address={address}
                            totalValue={totalValue}
                            {...asset}
                        />
                    )}
                    </tbody>
                </Table>
            </div>
        </Card>
    )
}

const Asset = ({name, code, value, balance, tokenAddress, address, totalValue}) => {
    return (
        <tr className='asset-balance'>
            <td className='hide-portrait'>
                {name}
            </td>
            <td className='numeric'>
                <Counter
                    amount={balance}
                    decimals={DECIMAL_FORMAT.FLEX_DEC}
                    suffix={` ${code}`}
                />
            </td>
            <td className='numeric'>
                <Counter
                    amount={value}
                    decimals={0}
                    suffix=' kr'
                />
            </td>
            <td className='numeric hide-portrait'>
                <Counter
                    amount={value / totalValue * 100}
                    decimals={2}
                    suffix='%'
                />
            </td>
            <td className='token-link hide-portrait'>
                {code !== 'ETH' &&
                <ExternalLink
                    href={`https://etherscan.io/token/${tokenAddress}?a=${address}`}
                    className='flex-vertical-center'
                >
                    token
                    <ExternalLinkIcon/>
                </ExternalLink>
                }
            </td>
        </tr>
    )
}